export default "__VITE_ASSET__CffGIRr___"